<template>
  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{title}}
          </h3>
        </div>
        <div class="col text-right">
          <base-button
            type="success"
            size="sm"
            icon="ni ni-fat-add"
            @click="$emit('create')"
          >
            New Game
          </base-button>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table class="table align-items-center table-flush"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                  tbody-classes="list"
                  :data="tableData">
        <template slot="columns">
          <th>Name</th>
          <th class="players">Teams</th>
          <th>Active</th>
          <th></th>
        </template>

        <template slot-scope="{row}">
          <th scope="row">
            <div class="media align-items-center">
              <div class="name" @click="$router.push({name: 'view live game', params: {id: row.id}})">
                <span class="name mb-0 text-sm">{{row.name}}</span>
              </div>
            </div>
          </th>
          <td class="players">
            {{row.liveteams ? row.liveteams.length : 0}}
          </td>
          <td>
            <badge class="badge-dot mr-4" :type="row.active ? 'success' : 'info'">
              <i :class="`bg-${row.active ? 'success' : 'info'}`"></i>
              <span class="status">{{row.active ? 'Active' : 'Inactive'}}</span>
            </badge>
          </td>

          <td class="text-right">
            <a
              class="btn btn-sm btn-icon-only text-light"
              role="button"
              href="#"
              @click.prevent="$emit('edit', row)"
            >
              <i class="fa fa-edit"></i>
            </a>
            <a
              class="btn btn-sm btn-icon-only text-light"
              role="button"
              href="#"
              @click.prevent="$emit('remove', row)"
            >
              <i class="fa fa-trash"></i>
            </a>
          </td>

        </template>

      </base-table>
    </div>

    <div class="card-footer d-flex justify-content-end"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <base-pagination :total="this.data.length" :perPage="perPage" v-model="currentPage"></base-pagination>
    </div>

  </div>
</template>
<script>
export default {
  name: 'LeaguesTable',
  props: {
    type: {
      type: String,
    },
    title: String,
    data: {
      type: Array,
    },
    perPage: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      currentPage: 1,
    };
  },
  computed: {
    tableData() {
      const startIndex = this.perPage * (this.currentPage - 1);
      const endIndex = this.perPage * this.currentPage;

      return this.data.slice(startIndex, endIndex);
    },
  },
};
</script>
<style type="scss" scoped>
  .players{
    text-align: center;
  }
  .name{
    cursor: pointer;
  }
</style>
